export default __webpack_public_path__ + "static/media/logoCrop.e0f3e46e.png";